type TViolationDetailProps = {
  id: number;
  title: string;
  value: string;
};
export const ViolationReportDetailItems: TViolationDetailProps[] = [
  {id: 0, title: 'محتوای غیرمرتبط با آگهی', value: 'irrelevant_content'},
  {id: 1, title: 'کلاهبرداری', value: 'scam'},
  {id: 2, title: 'اختلاف با صاحب آگهی', value: 'dispute'},
  {id: 3, title: 'تصویر نامناسب', value: 'inappropriate_image'},
  {id: 4, title: 'موارد دیگر', value: 'other'},
];
